import { categories } from "@/mocks/categories";

const allCategoryCards = [
  {
    ...categories[0],
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20white%20leather%20sneakers%20with%20cream%20accents%20placed%20on%20light%20terrazzo%20surface%20soft%20side%20lighting%20casting%20long%20shadow%20editorial%20product%20photography%20minimalist%20clean%20composition%20warm%20morning%20light&width=600&height=400&seq=cat-card-1&orientation=landscape",
    isLarge: true,
  },
  {
    ...categories[1],
    image: "https://readdy.ai/api/search-image?query=Oversized%20beige%20hoodie%20neatly%20folded%20on%20light%20oak%20wooden%20surface%20with%20textured%20fabric%20details%20visible%20soft%20diffused%20natural%20lighting%20minimalist%20Nordic%20editorial%20style%20clean%20warm%20aesthetic&width=600&height=400&seq=cat-card-2&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[2],
    image: "https://readdy.ai/api/search-image?query=White%20cotton%20graphic%20t-shirt%20flat%20on%20woven%20rattan%20surface%20with%20tropical%20plant%20shadow%20soft%20natural%20daylight%20editorial%20product%20photography%20clean%20minimalist%20composition%20warm%20neutral%20palette&width=600&height=400&seq=cat-card-3&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[3],
    image: "https://readdy.ai/api/search-image?query=Tan%20bomber%20jacket%20draped%20over%20modern%20chair%20with%20soft%20window%20light%20creating%20gentle%20highlights%20on%20fabric%20editorial%20product%20photography%20warm%20earthy%20tones%20minimalist%20composition%20elegant%20styling&width=600&height=400&seq=cat-card-4&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[4],
    image: "https://readdy.ai/api/search-image?query=Casual%20linen%20pants%20folded%20on%20light%20sand%20colored%20surface%20with%20soft%20texture%20visible%20gentle%20side%20lighting%20editorial%20product%20photography%20minimalist%20Mediterranean%20aesthetic%20warm%20natural%20feel&width=600&height=400&seq=cat-card-5&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[5],
    image: "https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20in%20cream%20color%20on%20smooth%20concrete%20surface%20with%20soft%20overhead%20lighting%20casting%20circular%20shadow%20editorial%20product%20photography%20clean%20modern%20composition%20warm%20neutral%20palette&width=600&height=400&seq=cat-card-6&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[6],
    image: "https://readdy.ai/api/search-image?query=Matching%20sweatshirt%20and%20jogger%20set%20in%20sage%20green%20folded%20together%20on%20light%20wooden%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20minimalist%20composition%20clean%20fresh%20aesthetic&width=600&height=400&seq=cat-card-7&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[7],
    image: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20basics%20neatly%20arranged%20on%20crisp%20white%20linen%20fabric%20soft%20diffused%20daylight%20editorial%20product%20photography%20minimalist%20clean%20composition%20warm%20gentle%20atmosphere&width=600&height=400&seq=cat-card-8&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[8],
    image: "https://readdy.ai/api/search-image?query=Football%20jersey%20in%20bold%20striped%20pattern%20displayed%20on%20dark%20slate%20surface%20with%20dramatic%20side%20lighting%20highlighting%20fabric%20texture%20editorial%20sports%20product%20photography%20clean%20dynamic%20composition&width=600&height=400&seq=cat-card-9&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[9],
    image: "https://readdy.ai/api/search-image?query=Designer%20sunglasses%20and%20minimalist%20watch%20arranged%20on%20light%20travertine%20stone%20surface%20soft%20golden%20hour%20lighting%20editorial%20luxury%20product%20photography%20clean%20elegant%20composition%20warm%20rich%20tones&width=600&height=400&seq=cat-card-10&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[10],
    image: "https://readdy.ai/api/search-image?query=Leather%20crossbody%20bag%20in%20warm%20cognac%20color%20on%20cream%20marble%20surface%20soft%20window%20light%20editorial%20product%20photography%20minimalist%20elegant%20composition%20rich%20texture%20details%20visible&width=600&height=400&seq=cat-card-11&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[11],
    image: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20coiled%20elegantly%20on%20smooth%20light%20stone%20surface%20with%20buckle%20detail%20catching%20light%20editorial%20product%20photography%20minimalist%20sophisticated%20composition%20warm%20earthy%20palette&width=600&height=400&seq=cat-card-12&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[12],
    image: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20with%20golden%20cap%20on%20dark%20wooden%20surface%20with%20soft%20dramatic%20lighting%20and%20gentle%20shadows%20editorial%20luxury%20product%20photography%20sophisticated%20atmosphere%20rich%20warm%20amber%20tones&width=600&height=400&seq=cat-card-13&orientation=landscape",
    isLarge: false,
  },
  {
    ...categories[13],
    image: "https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20and%20small%20items%20arranged%20in%20grid%20on%20light%20paper%20background%20soft%20overhead%20lighting%20editorial%20product%20flatlay%20clean%20organized%20composition%20warm%20neutral%20palette&width=600&height=400&seq=cat-card-14&orientation=landscape",
    isLarge: false,
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-foreground-400 mb-3 font-label">
            Browse Categories
          </p>
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-950">
            Explore Pandabuy Spreadsheet Categories
          </h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">
            Every category links directly to curated, verified Pandabuy spreadsheet collections on kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {allCategoryCards.map((card) => (
            <a
              key={card.name}
              href={card.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] ${
                card.isLarge ? "lg:row-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="absolute inset-0">
                <img
                  src={card.image}
                  alt={card.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="relative z-10 h-full flex flex-col justify-end p-4 md:p-5 min-h-[140px] md:min-h-[180px]">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${card.icon} text-white text-sm`}></i>
                  </div>
                </div>
                <h3 className="text-white font-semibold text-sm md:text-base whitespace-nowrap">
                  {card.name}
                </h3>
                <span className="text-white/60 text-xs mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  View Spreadsheet →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}